module.exports = __webpack_public_path__ + "img/gallery12.e74a575a.png";